export enum LookupDataSource {
    countryGoup,
    discountLevel,
    managedBy,
    accountStatus,
    shippingMethods,
    clubs
}
